import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { ChatStatusService } from '../../core';
import { CmpsTeamscallTeamschatSummaryModule } from '../teamschat-summary/teamschat-summary.module';

import { CmpsCoachingChatBoxModule } from './../../../coaching/detail/teamschat-dialog/chat-box/chat-box.module';
import { ChatMenuDialogComponent } from './chat-menu-dialog.component';
import { TranslationIdMap } from './chat-menu-dialog.i18n';
import { ChatMenuDialogService } from './chat-menu-dialog.service';

@NgModule({
    declarations: [ChatMenuDialogComponent],
    providers: [ChatMenuDialogService, ChatStatusService],
    imports: [
        CmpsButtonModule,
        CmpsCoachingChatBoxModule,
        CmpsCommonModule,
        CmpsTeamscallTeamschatSummaryModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
        ReactiveFormsModule,
    ],
})
export class CmpsTeamsCallChatMenuDialogModule {}
